// src/features/insurancePlan/page/PlanGroup

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import { Button, Tag } from 'antd'; //Space, Tag,
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { CountryType } from '../../types/lookupTypes';
import { router } from '../../../../app/routing';
import { useTranslation } from 'react-i18next';



const CountryPage = () => {
    const { t } = useTranslation();

    // Define columns for the PlanGroup table
    const CountryColumns: ColumnsType<CountryType> = [
        {
            title: 'Name',
            key: 'name',
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        router.navigate({
                            to: '/lookup/country/CountryFormRoute', // Corrected path
                            state: { record: record } as Record<string, unknown>,
                        });
                    }}
                >
                    {record.name}
                </Button>
            ),
        },
        { title: "Name", dataIndex: "name", key: "name" },
        {
            title: "BelongsToEurope",
            dataIndex: "belongsToEurope",
            key: "belongsToEurope",
            render: (isActive: boolean) => (
                <Tag color={isActive ? "green" : "red"}>{isActive ? "Yes" : "No"}</Tag>
            ),
        },

    ];

    return (
        <div>

            <DynamicTable<CountryType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.LOOKUP.GET_COUNTRY} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.LOOKUP.COUNTRY} // Unique query key for menus
                columns={CountryColumns}
                showActions={false} // Set to true if you want Edit/Delete actions
                // Pass the fields you want the search bar to filter
                tableTitle={t("Country")}
                filterConfigs={[
                    { field: "name", placeholder: t("SearchbyName") },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.LOOKUP.EXPORT_COUNTRY,
                            fileName: "Countries",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Belongs To Europe", key: "belongsToEurope" },
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default CountryPage;